import { render, staticRenderFns } from "./chief-menu.html?vue&type=template&id=1a1fd8b6&scoped=true&"
import script from "./chief-menu.js?vue&type=script&lang=js&"
export * from "./chief-menu.js?vue&type=script&lang=js&"
import style0 from "./chief-menu.css?vue&type=style&index=0&id=1a1fd8b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1fd8b6",
  null
  
)

export default component.exports